import React, { useEffect, useState } from 'react';
export function Countdown({
  variant = 'dark'
}: {
  variant?: 'dark' | 'light' | 'red';
}) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  const colors = {
    dark: 'bg-gray-900 text-white',
    light: 'bg-white text-amber-900 shadow-md',
    red: 'bg-red-700 text-white'
  };
  return <div className="flex items-center gap-2 font-mono font-bold" data-id="element-7">
      <div className={`px-2 py-1 rounded ${colors[variant]}`} data-id="element-8">
        {format(timeLeft.hours)}
      </div>
      <span data-id="element-9">:</span>
      <div className={`px-2 py-1 rounded ${colors[variant]}`} data-id="element-10">
        {format(timeLeft.minutes)}
      </div>
      <span data-id="element-11">:</span>
      <div className={`px-2 py-1 rounded ${colors[variant]}`} data-id="element-12">
        {format(timeLeft.seconds)}
      </div>
    </div>;
}